<template>
<div class="shopping-cart--overview">
    <div class="row">
        <div class="col-12 text-center">
            <br><br>
            <h2>PREGLED NAROČILA</h2>
            <br><br>
            Prosimo vas, da še enkrat pregledate vse podatke, če so pravilno vpisani, če so količine in vrste artiklov pravilne in nato potrdite naročilo.<br>
            Na vaš email boste prejeli naročilo. Čas dostave od prejetega plačila je 2 do 3 delovne dni.<br>
            Za dodatne informacije o paketu smo vam na voljo na 040 59 80 80 med delovniki med 8. in 16. uro.
            <br><br><br><br>
        </div>
    </div>
    <div class="row detailOrder">
        <div class="col-12">
            <div class="row">
                <div class="col-2 d-none d-md-block tableHeader">Št Artikla</div>
                <div class="col-md-4 col-6 d-none d-sm-block tableHeader">Naziv</div>
                <div class="col-sm-2 col-4 tableHeader">Količina</div>
                <div class="col-sm-2 col-4 tableHeader text-center">Popust</div>
                <div class="col-sm-2 col-4 tableHeader text-right">Vrednost</div>
            </div>
            <div class="row" v-for="item in items" :key="item.rowId">
                <div class="col-2 d-none d-md-block tableContent">{{ item.article_nr }}</div>
                <div class="col-md-4 col-sm-6 col-12 tableContent topRow">{{ item.name }}7</div>
                <div class="col-sm-2 col-4 tableContent">{{ item.qty }} {{ item.unit }}</div>
                <div class="col-sm-2 col-4 tableContent text-center">{{ item.discount }} %</div>
                <div class="col-sm-2 col-4 tableContent text-right">{{ item.price * item.qty | money }}</div>
            </div>
            <div class="row justify-content-end">
                <div class="col-md-4 col-sm-6 col-12">
                    <div class="row">
                        <div class="col-8 col-sm-6 tableContentSum">Skupaj:</div>
                        <div class="col-4 col-sm-6 text-right tableContentSum">{{ brutto | money }}</div>
                    </div>
                    <div class="row">
                        <div class="col-8 col-sm-6 tableContentSum">Vrednost popusta:</div>
                        <div class="col-4 col-sm-6 text-right tableContentSum">{{ discount | money }}</div>
                    </div>
                    <div class="row">
                        <div class="col-8 col-sm-6 tableContentSum">Darilni bon:</div>
                        <div class="col-4 col-sm-6 text-right tableContentSum">{{ 0 | money }}</div>
                    </div>
                    <div class="row">
                        <div class="col-8 col-sm-6 tableContentSum">Skupaj brez DDV:</div>
                        <div class="col-4 col-sm-6 text-right tableContentSum">{{ netto | money }}</div>
                    </div>
                    <div class="row">
                        <div class="col-8 col-sm-6 tableContentSum">DDV ({{$t('app.vat')}} %):</div>
                        <div class="col-4 col-sm-6 text-right tableContentSum">{{ tax | money }}</div>
                    </div>
                    <div class="row">
                        <div class="col-8 col-sm-6 tableContentSum">Dostava:</div>
                        <div class="col-4 col-sm-6 text-right tableContentSum">{{ shipping | money }}</div>
                    </div>
                    <div class="row">
                        <div class="col-8 col-sm-6 tableContentTotal">Skupaj za plačilo:</div>
                        <div class="col-4 col-sm-6 text-right tableContentTotal">{{ total | money }}</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <table>
                        <colgroup>
                            <col width="1px" />
                        </colgroup>
                        <tr>
                            <td class="title">Dostavni&nbsp;naslov:</td>
                            <td>{{ deliveryAddress }}</td>
                        </tr>
                        <tr>
                            <td class="title">Dostavna&nbsp;služba:</td>
                            <td>{{ deliveryName }}</td>
                        </tr>
                        <tr>
                            <td class="title">Način&nbsp;plačila:</td>
                            <td>{{ paymentName }}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { createNamespacedHelpers as nsHelper } from 'vuex'

const {
  mapState: mapCartState,
  mapGetters: mapCartGetters
} = nsHelper('cart')

const {
  mapGetters: mapShippingGetters
} = nsHelper('cart/shipping')

const {
  mapGetters: mapPaymentGetters
} = nsHelper('cart/payment')

export default {

  computed: {
    ...mapCartState(['items']),
    ...mapCartGetters(['count', 'total', 'brutto', 'brutto_discounted', 'netto', 'discount', 'tax', 'shipping']),
    ...mapShippingGetters(['deliveryName', 'deliveryAddress']),
    ...mapPaymentGetters(['paymentName'])
  },

  filters: {
    money (value) {
      return parseFloat(value).toLocaleString('sl-SI', {style: 'currency', currency: 'EUR'})
    }
  }

}
</script>
